module.exports = __webpack_public_path__ + "static/media/icn_allert.3828ad1c.svg";